import React from 'react';
import { useParams } from 'react-router-dom';
import { DealRouteGuard } from '@/components/layouts/RecordRouteGuard/DealRouteGuard';
import { Box } from '@mui/material';
import DebtorViewWrapper from '@/components/views/DebtorsView/DebtorViewWrapper';

const ViewDebtorsPage = () => {
	const { dealId } = useParams();

	// Keyed so switching deals (e.g. via global search) remounts the view instead of showing the old deal's data.
	return (
		<DealRouteGuard>
			<Box pb={3}>
				<DebtorViewWrapper key={dealId} />
			</Box>
		</DealRouteGuard>
	);
};

export default ViewDebtorsPage;
